import { render, staticRenderFns } from "./training-edit.vue?vue&type=template&id=2e87b4a6&lang=pug"
import script from "./training-edit.vue?vue&type=script&lang=js"
export * from "./training-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports